// The feature's public surface: how to render a conversation, what a host must supply to
// identify one, and the REST contract a host has to implement. The manager, the socket
// transport and the merge helpers are internal — the manager in particular is provided per
// conversation and misbehaves anywhere else.
export * from './order-chat.module';
export * from './components/order-chat-conversation/order-chat-conversation.component';
export * from './models/index';
export * from './services/chat-conversation-gateway';
